import type * as React from "react";

import { StyledItemIcon } from "pro-features/components/core cells/src/CoreRecentCell/StyledComponents";
import { TextContainer } from "pro-features/components/core cells/src/CoreWebsiteCell/StyledComponents";

import { DomainNameAndIconWrapper } from "../StyledComponent";

type DomainNameAndIconProps = {
    icon: any;
    domain: any;
    className?: string;
};

export const DomainNameAndIcon: React.FC<DomainNameAndIconProps> = ({ icon, domain, className }) => {
    return (
        <DomainNameAndIconWrapper className={className}>
            <StyledItemIcon iconSrc={icon} />
            <TextContainer>{domain}</TextContainer>
        </DomainNameAndIconWrapper>
    );
};
